module.exports = __webpack_public_path__ + "img/colored-rounded.1e80416a.svg";